import HotSpotMarker from "./HotSpotMarker";

export default class UpdateHotSpotModel {
    assetId = null;
    scanId = null;
    id = null;
    transform = null;
    isActive = null;
    inspectionAreaId = null;
    anomalyIds = null;
    eTag = null;

    constructor(updatedHotSpot) {
        if (updatedHotSpot instanceof HotSpotMarker) {
            this.id = updatedHotSpot.id;
            this.assetId = updatedHotSpot.assetId;
            this.scanId = updatedHotSpot.scanId;
            this.transform = updatedHotSpot.transform;
            this.isActive = updatedHotSpot.isActive;
            this.anomalyIds = updatedHotSpot.anomalyIds;
            this.inspectionAreaId = updatedHotSpot.inspectionAreaId;
            this.eTag = updatedHotSpot.eTag;
        }
    }
}